import React from 'react';
// project imports
import PublicLayout from 'views/layouts/PublicLayout/Home';
import GuestGuard from 'routes/route-guard/GuestGuard';
import HomePage from 'views/pages/home/homePage';
import Careers from 'views/pages/Careers/Careers';
import ScreeningPage from 'views/pages/landing/screening';
import PrivacyPage from 'views/pages/privacy/PrivacyPolicy';
import Contact from 'views/pages/Contact/Contact';
import About from 'views/pages/About/About';
import ParentEd from 'views/pages/ParentEd/ParentEd';
import ResourceSample from 'views/pages/ResourceSample/ResourceSample';
import Services from 'views/pages/Services/Services';
import DiagnosticScreeningServices from 'views/pages/DiagnosticScreeningServices';
import TherapeuticServices from 'views/pages/TherapeuticServices/TherapeuticServices';
import NotFoundCover from 'views/pages/Static/NotFoundCover/NotFoundCover';
import PrivacyPolicy from 'views/pages/Static/Privacy/PrivacyPolicy';
import GrievanceView from 'views/pages/Static/Grievance/GrievanceView';
import TermsAndConditions from 'views/pages/Static/Terms/TermsAndConditions';
import PatientRights from 'views/pages/Static/PatientRights/PatientRights';
import NonDiscriminationCompliance from 'views/pages/Static/NonDiscrimination/NonDiscriminationCompliance';

const HomeRoutes = {
	path: '/',
	element: (
		<GuestGuard>
			<PublicLayout />
		</GuestGuard>
	),
	children: [
		{
			path: '/',
			element: <HomePage />
		},
		{
			path: '/services',
			element: <Services />
		},
		{
			path: '/contact',
			element: <Contact/>
		},
		{
			path: '/about',
			element: <About />
		},
		{
			path: '/careers',
			element: <Careers/>
		},
		{
			path: '/services/screening',
			element: <ScreeningPage /> //ERROR//
		},
		{
			path: '/services/diagnostics',
			element: <DiagnosticScreeningServices />
		},
		{
			path: '/services/therapy',
			element: <TherapeuticServices />
		},
		{
			path: '/privacy',
			element: <PrivacyPage /> 
		},
		{
			path: '/services/parents',
			element: <ParentEd /> 
		},
		{
			path: '/resources/*',
			element: <ResourceSample />
		},
		{
			path: '/not-found-cover',
			element: <NotFoundCover /> 
		},
		{
			path: '/faqs',
			element: <PrivacyPolicy title='FAQS' /> 
		},
		{
			path: '/privacy',
			element: <PrivacyPolicy /> 
		},
		{
			path: '/grievance',
			element: <GrievanceView /> 
		},
		{
			path: '/terms',
			element: <TermsAndConditions /> 
		},
		{
			path: '/patient_rights',
			element: <PatientRights />  
		},
		{
			path: '/non_discrimination',
			element: <NonDiscriminationCompliance /> 
		},
		{
			path: '/data_confidentiality',  
			element: <PrivacyPolicy title='Data Confidentiality' />
		}

	]
};

export default HomeRoutes;
